import StarIcon from '@/storybook/icons/StarIcon';
import EditIcon from '@/storybook/icons/EditIcon';
import styles from './RatingStars.module.css';
import { useCallback } from 'react';

export type Props = {
  'rate'?: number;
  'onClick'?: VoidFunction;
  'data-testid'?: string;
};

export default function RatingStars({ rate = 0, onClick, 'data-testid': dataTestId = 'ratingStars' }: Props) {
  const handleOnClick = useCallback(
    (e: React.MouseEvent<SVGElement, MouseEvent>) => {
      if (!onClick) return;
      e.stopPropagation();
      onClick();
    },
    [onClick],
  );

  const isStarActive = useCallback((index: number) => index <= rate - 1, [rate]);

  return (
    <div className={styles.ratingStarsContainer} data-testid={dataTestId} data-rate={rate}>
      <section className={styles.ratingStars}>
        {Array.from({ length: 5 }, (_, index: number) => (
          <StarIcon
            key={`ratingStar-${index}`}
            className={styles.starIcon}
            data-is-star-active={isStarActive(index)}
            data-testid="ratingStarIcon"
          />
        ))}
      </section>
      {onClick && <EditIcon className={styles.editIcon} onClick={e => handleOnClick(e)} data-testid="ratingStarEdit" />}
    </div>
  );
}
